import { useQuery } from '@tanstack/react-query';
import { TattooChoices } from '@prisma/client';
import useUser from '../global/useUser';
import { getSizeOptions } from '../../services/global';

function useSizeOptions() {
  const { user } = useUser();

  const queryKey = ['sizeOptions', user?.employee?.employeeId];

  const {
    data: sizeOptions,
    isLoading,
    isFetching,
    isRefetching,
    refetch,
    isError,
  } = useQuery<TattooChoices[]>({
    queryKey,
    queryFn: getSizeOptions,
    enabled: !!user?.employee?.employeeId,
  });

  return {
    sizeOptions,
    isLoading,
    isFetching,
    isRefetching,
    refetch,
    isError,
  };
}

export default useSizeOptions;
